export default __webpack_public_path__ + "static/media/RightHand.e4815e15.svg";